<style lang="stylus">
        .album-box
            padding-top 16px
            .album-box-bg
                width 100%
                margin-top 16px
                object-fit contain
                img
                    width 100%
            .album-box__title
                font-size 18px
                padding-bottom 20px
                .album-box__title-community
                    color #000
                    cursor pointer
                    &:hover
                        color #017fff
                .album-box__title-album
                    color #606266
            .album-box__menu
                display flex
                flex-wrap wrap
                justify-content space-between
                .album-box_list
                    width 23.5%
                    max-width 301px
                    margin-bottom 30px
                    border-radius 6px 6px 0 0
                    @media screen and (max-width: 1000px)
                        width 30%
                    @media screen and (max-width: 650px)
                        width 48%
                    img
                        display block
                        max-width 100%
                        cursor pointer
                    .album-box_info
                        height 56px
                        background #fff
                        display flex
                        justify-content space-between
                        align-items center
                        padding 0 10px
                        border-radius 0 0 6px 6px
                        .album-box_title
                            font-size 14px
                            color #000
                        .album-box-pv
                            display flex
                            align-items center
                            svg
                                width 14px
                                height 14px
                                fill #b8b8b8
                                margin-right 3px
                            p
                                color #b8b8b8
                                font-size 12px
    .albumDetail-backicon
        width 20px
        height 12px
        padding 0 4px
        svg
            width 12px
            height 12px
            transform rotate(180deg)
            stroke #424242
    .album-box.dark-theme_albumlist
        background #222
        .album-box__title
            .album-box__title-community
                color #fff
            .album-box__title-album
                color #fff
            .albumDetail-backicon
                fill #fff
                stroke #fff
</style>

<template>
    <div ref="albumListBox" class="album-box container" :class="{ 'dark-theme_albumlist': isPCDarkMode == 2 }">
        <div class="album-box-bg" v-if="false">
            <img :src="require('@/home/assets/img/album-bg.png')" alt="" />
        </div>
        <div class="album-box__title">
            <span class="album-box__title-community" @click="showTemplateCommunity">{{ albumBoxTitle.community }}</span>
            <span class="album-box__title-album">
                <span class="albumDetail-backicon">
                    <iconSymbol name="preview-back" />
                </span>
                {{ albumBoxTitle.album }}
            </span>
        </div>
        <div class="album-box__menu">
            <div
                class="album-box_list"
                v-for="(albumList, index) in $store.state.tplCenter.albumList"
                :data-locate="`album-${index}`"
                @click="showAlbumList(index)"
            >
                <img :src="window['GLOBAL'].PUBLIC_OSS_HOST + albumList.cover_url + 'main.png'" alt="" />
                <div class="album-box_info">
                    <p class="album-box_title">{{ albumList.title }}</p>
                </div>
            </div>
            <div class="album-box_list" v-for="item in tempList" :key="`temp-${item}`"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "albumList",
        data() {
            return {
                albumBoxTitle: {
                    community: "模板社区",
                    album: "全部专辑",
                },
                flag: false,
                tempList: [],
            };
        },
        computed: {
            baseOrder() {
                return this.$store.state.baseOrder;
            },
        },
        methods: {
            showTemplateCommunity: function () {
                this.$bus.$emit("updateFilter", {
                    album: null,
                    page: 1,
                    offset: 0,
                });
                this.$store.commit("toTplCenter", {
                    name: "activeAlbumID",
                    data: -1,
                });
                this.$store.commit("toTplCenter", {
                    name: "albumPageStatus",
                    data: "default",
                });
                this.$bus.$emit("initWorkClass");
            },
            showAlbumList: function (index) {
                this.sensors.track("albumPage", {
                    Catalogues: "Templates",
                    platform: this.isPC ? "desktop" : "online",
                });
                this.$store.commit("toTplCenter", {
                    name: "activeAlbumID",
                    data: this.$store.state.tplCenter.albumList[index].id,
                });
                this.$store.commit("toTplCenter", {
                    name: "albumPageStatus",
                    data: "detail",
                });
                this.$bus.$emit("clearSearch");
                this.$bus.$emit("updateFilter", {
                    page: 1,
                    album: this.$store.state.tplCenter.albumList[index].id,
                    offset: 0,
                    order: this.baseOrder,
                    price: "1",
                    classId: 0,
                });
                this.$store.commit("cleanActiveLab", this.$store.state.tplCenter.editorTags);
                this.$store.commit("toTplCenter", {
                    name: "showAllAlbumBreadcrumb",
                    data: true,
                });
            },
            fitScreen() {
                let total = this.$store.state.tplCenter.albumList.length;
                let box = this.$refs.albumListBox;
                if (box) {
                    let boxW = box.clientWidth;
                    let num = 4;
                    if (boxW < 300) {
                        num = 2;
                    } else if (boxW < 650) {
                        num = 3;
                    } else if (boxW < 1500) {
                        num = 4;
                    } else {
                        let blockWidth = Math.min(boxW * 0.235, 301);
                        num = Math.floor(boxW / blockWidth);
                    }
                    this.flag = false;
                    this.tempList = [];
                    let block = total % num;
                    if (block) {
                        for (let i = block; i < num; i++) {
                            this.tempList.push(i);
                        }
                    }
                    console.log(total % num, num, this.tempList);
                }
            },
            resizeFit() {
                if (this.flag) return;
                this.flag = true;
                setTimeout(() => {
                    this.fitScreen();
                }, 100);
            },
        },
        created() {
            this.fitScreen();
            window.addEventListener("resize", this.resizeFit);
        },
        mounted() {
            this.fitScreen();
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resizeFit);
        },
    };
</script>
